import axios from "axios";
import '../utils/axios.interceptor';
import { urlBucketBack } from "../configs/config";
const epName = "v1/bucket/";
const nameItemsText = "Files Bucket";
const nameItemText = "File Bucket";
const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
const unUna = itemGender === "M" ? "un" : "una";

// #############################################################################
// getFileBucket by id

export const getByIdFileBucket = async (idS3) => {
	let _errorMessage = `No fue posible obtener ${elLa} ${nameItemText}`;

	try {
		const response = await axios({
			method: "GET",
			url: `${urlBucketBack}${epName}`,
			params: {
				id_s3: idS3,
			},
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				response.messageText = `${nameItemText} obtenido`;
				response.messageSeverity = "success";
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
}


//
// #############################################################################
// deleteFileBucket

export const deleteFileBucket = async (idS3) => {
	let _errorMessage = `No fue posible eliminar ${elLa} ${nameItemText}`;

	try {
		const response = await axios({
			method: "DELETE",
			url: `${urlBucketBack}${epName}`,
			params: {
				id_s3: idS3,
			},
		});

		if (response.status === 200) {
			let _error = "status" in response.data && response.data.status === "error";
			if (!_error) {
				// si no hay error controlado
				response.ok = true;
				response.messageText = `${nameItemText} eliminado`;
				response.messageSeverity = "success";
				return response;
			}
		}

		// si hay algun error controlado

		console.log(_errorMessage);
		console.log(response);

		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	} catch (error) {
		console.log(_errorMessage);
		if (error.response) {
			// The request was made and the server responded with a status code that falls out of the range of 2xx
			console.log(error.response);
		} else if (error.request) {
			// The request was made but no response was received
			// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
			// http.ClientRequest in node.js
			console.log(error.request);
		} else {
			// Something happened in setting up the request that triggered an Error
			console.log(error);
		}
		let response = {};
		response.ok = false;
		response.messageText = _errorMessage;
		response.messageSeverity = "error";
		return response;
	}
}

// #############################################################################
// getFileByUrl

export const getFileByUrl = (idS3) => {
	const urlBucket = urlBucketBack + epName + "?id_s3=";
	let _errorMessage = `No fue posible obtener ${elLa} ${nameItemText}`;
	let finalUrl = `${urlBucket}${idS3}`;
	if (idS3 === undefined || idS3 === null || idS3 === "") {
		// si no hay idS3
		console.log(_errorMessage);
		finalUrl = "";
	} else {
		// si hay idS3
		finalUrl = `${urlBucket}${idS3}`;
	}
	return finalUrl;
}






